import { EmailStep } from './EmailStep'
import { CodeStep } from './CodeStep'
import { NameStep } from './NameStep'
import { OfferTelegramStep } from './OfferTelegramStep'
import { useAuthFlow } from '../model/useAuthFlow'
import { ENV } from '@shared/config/env'
import { TelegramAuthButton } from '@features/telegram-auth'
import styles from './AuthFlow.module.css'

interface AuthFlowProps {
  /** URL для редиректа после успешного прохождения флоу */
  redirectTo: string
}

/**
 * Главный компонент флоу веб-авторизации.
 * @param redirectTo - URL для редиректа после успеха
 */
export const AuthFlow = ({ redirectTo }: AuthFlowProps) => {
  const {
    state, submitting, shakeSignal, debugCode,
    handleEmailSubmit, handleResend, handleVerify, handleNameSubmit, handleOfferTelegramNext, changeEmail
  } = useAuthFlow({ redirectTo })

  return (
    <>
      {ENV.IS_DEV && debugCode && (
        <div className={styles.debug}>debug code: {debugCode}</div>
      )}

      {state.step === 'email' && (
        <>
          <EmailStep
            initialEmail={state.email}
            onSubmit={handleEmailSubmit}
            isSubmitting={submitting}
            errorText={state.error}
          />
          {ENV.IS_WEB && <TelegramAuthButton redirectTo={redirectTo} />}
        </>
      )}

      {state.step === 'code' && (
        <CodeStep
          email={state.email}
          onSubmit={handleVerify}
          onResend={handleResend}
          onChangeEmail={changeEmail}
          errorText={state.error}
          attemptsLeft={state.attemptsLeft}
          isLocked={state.isLocked}
          nextResendAt={state.nextResendAt}
          isSubmitting={submitting}
          shakeSignal={shakeSignal}
        />
      )}

      {state.step === 'offer-telegram' && (
        <OfferTelegramStep
          onSkip={handleOfferTelegramNext}
          onLinked={handleOfferTelegramNext}
        />
      )}

      {state.step === 'name' && (
        <NameStep
          onSubmit={handleNameSubmit}
          isSubmitting={submitting}
          errorText={state.error}
        />
      )}
    </>
  )
}
